import { WHATSAPP } from '../../constants';
import percarbonato from '../../assets/banners/percarbonato.jpg';
import bicarbonato from '../../assets/banners/bicarbonato.jpg';
import vinagre from '../../assets/banners/vinagre.jpg';
import magicpowder from '../../assets/banners/magicpowder.jpg';
import acido from '../../assets/banners/alumbre.jpg';
import borax from '../../assets/banners/borax.jpg';
import tierra from '../../assets/banners/tierra.jpg';
import './products.css';

const products = [
  {
    name: 'Magic Powder',
    img: magicpowder,
    desc: 'Limpiador multiusos en polvo. Ideal para ropa blanca, manchas difíciles y limpieza general del hogar.',
  },
  {
    name: 'Percarbonato de Sodio',
    img: percarbonato,
    desc: 'Blanqueador y quitamanchas natural con oxígeno activo. Potencia el detergente y saca manchas difíciles.',
  },
  {
    name: 'Bicarbonato de Sodio',
    img: bicarbonato,
    desc: 'Multiusos: desodoriza, desengrasa, limpia superficies, ablanda el agua y más. Un básico eco-friendly.',
  },
  {
    name: 'Vinagre Concentrado',
    img: vinagre,
    desc: 'Antical y desincrustante natural. Disuelve sarro, manchas minerales y de óxido. Ideal para baño y cocina.',
  },
  {
    name: 'Ácido Cítrico',
    img: acido,
    desc: 'Desincrustante natural, ideal para sarro, cal y manchas minerales. Alternativa ecológica al vinagre.',
  },
  {
    name: 'Bórax',
    img: borax,
    desc: 'Aliado contra suciedad, bacterias e insectos. Para pisos, paredes, manchas de ropa y desinfección.',
  },
  {
    name: 'Tierra de Diatomeas',
    img: tierra,
    desc: 'Insecticida natural y desodorizante. Sirve para control de plagas domésticas y jardín, libre de tóxicos.',
  },
];

function Products() {
  return (
    <section id="products" className="section products">
      <div className="container">
        <div className="products__header">
          <span className="section-label">Productos estrella</span>
          <h2 className="section-title">Lo esencial para una limpieza consciente</h2>
          <p className="section-subtitle">Cada producto tiene un propósito. Te explicamos para qué sirve y cómo usarlo.</p>
        </div>
        <div className="products__grid">
          {products.map((p) => (
            <div key={p.name} className="card products__card">
              <img src={p.img} alt={p.name} className="products__img" loading="lazy" />
              <div className="products__body">
                <h3 className="products__name">{p.name}</h3>
                <p className="products__desc">{p.desc}</p>
                <a
                  href={WHATSAPP.product(p.name)}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-whatsapp btn-sm"
                >
                  Consultar este producto
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;
